import { lazy } from 'react';

export const AdMediumMapping = {
  Products: lazy(() => import('./containers/Products')),
  Mappings: lazy(() => import('./containers/Mappings')),
};
